import React from 'react'
import styled from 'styled-components'
import Datetime from 'react-datetime'
import moment from 'moment'
import {CalendarToday} from '@material-ui/icons'
import {Popover} from '@material-ui/core'
import './index.css'

const Input = styled.input`
    width: 100%;
	padding: 6px 0 7px;
	height: 19px;
	font-size: 16px;

    + div {
        left: 0;
        right: 0;
        bottom: 0;
        content: "";
        position: absolute;
        transform: scaleX(0);
        pointer-events: none;
		transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
		border-bottom: 2px solid #415dd4;
    }

	:focus {
        + div {
            transform: scaleX(1);
        }
    }

	${props => props.invalid && `
		+ div {
			border-bottom: 2px solid #f44336;
			transform: scaleX(1);
		}
	`}

	${props => !props.invalid && `
		:focus {
			+ div {
				transform: scaleX(1);
			}
		}
	`}
`

const Label = styled.div`
	font-weight: 700;
	font-size: 13.5px;
	line-height: 1;
	margin-bottom: 5px;
`

const Container = styled.div`
	box-sizing: border-box;
	position: relative;
	margin-bottom: 30px;

	&:before {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.42);
	}

	:hover {
		&:before {
			border-bottom: 2px solid #4a4a4a;
		}
	}
`

const Icon = styled.span`
	position: absolute;
	right: 0;
    cursor: pointer;
`

class Date extends React.PureComponent {
	constructor(props) {
        super(props)

        const timeFormat = this.getTimeFormat(props.config)

        let formattedValue

        if (props.defaultValue && moment(props.defaultValue, moment.ISO_8601).isValid()) {
            if (props.config) {
                if (props.config.timezone) {
                    formattedValue = moment.tz(props.defaultValue, props.config.timezone).format(props.config.format)
                } else {
                    formattedValue = moment(props.defaultValue).format(props.config.format)
                }
            } else {
                formattedValue = moment(props.defaultValue).format('DD MMM YYYY')
            }
        } else {
            formattedValue = ''
        }

        this.state = {
            anchorEl: null,
            formattedValue,
            value: moment(props.defaultValue, moment.ISO_8601).isValid() ? moment(props.defaultValue) : moment(),
            format: props.config ? props.config.format : 'DD MMM YYYY',
            timeFormat: timeFormat
        }
    }

	getTimeFormat(config) {
        let timeFormat
        if (config && config.format) {
            if (config.type === 'dateonly') {
                timeFormat = false
            } else {
                const index = config.format.indexOf('H') !== -1 ? config.format.indexOf('H') : config.format.indexOf('h')
                timeFormat = index !== -1 ? config.format.slice(index) : false
            }
        } else {
            timeFormat = 'HH:mm'
        }

        return timeFormat
    }

	onChange = (e) => {
		this.setState({
			formattedValue: e.currentTarget.value
		})
    }

	handleChange = (e) => {
		if (this.state.previousValue !== e.currentTarget.value) {
			if (moment(e.currentTarget.value, this.state.format, true).isValid()) {
				this.setState({
					value: moment(e.currentTarget.value, this.state.format),
					formattedValue: moment(e.currentTarget.value, this.state.format).format(this.state.format)
				}, () => this.props.handleChange('c' + this.props.fieldId, this.state.value.toISOString()))
			} else if (e.currentTarget.value === '') {
				this.setState({
					value: moment(),
					formattedValue: ''
				}, () => this.props.handleChange('c' + this.props.fieldId, this.state.formattedValue))
			} else {
				this.setState({
					value: this.state.previousValue !== '' ? moment(this.state.previousValue, this.state.format) : moment(),
					formattedValue: this.state.previousValue !== '' ? moment(this.state.previousValue, this.state.format).format(this.state.format) : ''
				})
			}
		}
    }

	onFocus = (e) => {
		this.setState({
			previousValue: e.currentTarget.value
		})
    }

	handleClick = (e) => {
		this.setState({
			anchorEl: e.currentTarget
		})
    }

	handleClose = () => {
        this.setState({
            anchorEl: null
        })
    }

	handleSelect = (value) => {
        this.setState({
            value,
            formattedValue:  moment(value).format(this.state.format)
        }, () => this.props.handleChange('c' + this.props.fieldId, value.toISOString()))
    }

	render() {
		const {invalid, fieldId, readonly, label} = this.props
		return (
			<Container data-id={invalid ? fieldId : null}>
				<Label dangerouslySetInnerHTML={{__html: label}} />
				<Input
					value={this.state.formattedValue}
					onChange={this.onChange}
					onFocus={this.onFocus}
					onBlur={this.handleChange}
					readOnly={readonly}
					invalid={invalid}
				/>
				<div />
				{!readonly &&
					<Icon>
						<CalendarToday onClick={this.handleClick} />
					</Icon>
				}
				{this.state.anchorEl &&
                    <Popover
                        open={!!this.state.anchorEl}
                        anchorEl={this.state.anchorEl}
                        onClose={this.handleClose}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                        }}
                    >
                        <Datetime
                            dateFormat={this.state.format}
                            timeFormat={this.state.timeFormat}
                            input={false}
                            open={true}
                            value={this.state.value}
                            onChange={this.handleSelect}
                            displayTimeZone={this.props.config ? this.props.config.timezone : null}
                        />
                    </Popover>
                }

			</Container>
		)
	}
}

export default Date